import React, { useEffect, useState } from "react";
import { Avatar, Badge, notification, Spin, Table, Tooltip } from "antd";
import { useSelector } from "react-redux";
import "../../assets/css/table-cell.css";
import "../../assets/css/common-table.css";
import "../../assets/css/employer-modal.css"
import phoneIcon from "../../assets/icons/akar-icons_phone.svg";
import locationIcon from "../../assets/icons/akar-icons_location.svg";
import emailIcon from "../../assets/icons/carbon_email.svg";
import resumeIcon from "../../assets/icons/documents icon .svg";
import citizenShipIcon from "../../assets/icons/bi_person-check.svg";
import chaticon from "../../assets/icons/cil_chat-bubble.svg";
import chaticonGrey from "../../assets/icons/cil_chat-bubble-Grey.svg";
import GreenTik from "../../assets/icons/GreenTik.svg";
import { impersonate } from "../../utils/Utils";
import dayjs from "dayjs";
import { AiFillStar } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import ModalCommon from "../common/ModalCommon";
import { HTTP_RESPONSE_CODES, USER_TYPE } from "../../constant";
import candidateApi from "../../features/candidate/api";

const columns = [
  {
    title: "Candidate Details",
    dataIndex: "candidate_details",
    key: "candidate_details",
  },
  {
    title: "Private",
    dataIndex: "private",
    key: "private",
  },
  {
    title: "Info",
    dataIndex: "info",
    key: "info",
  },
  {
    title: "Profession",
    dataIndex: "profession",
    key: "profession",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Message",
    dataIndex: "message",
    key: "message",
  },
];

const AuthenticationProviderName = [
  "Local",
  "Facebook",
  "LinkedIn",
  "Google",
  "Apple",
  "Live",
  "GitHub",
  "Yahoo",
];

export default function CandidateTable({fetchCandidates}) {
  const { candidates, isLoading } = useSelector((state) => state.candidate);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [removeCandidateLoading, setRemoveCandidateLoading] = useState({})

  var relativeTime = require("dayjs/plugin/relativeTime");
  var localizedFormat = require("dayjs/plugin/localizedFormat");
  dayjs.extend(relativeTime);
  dayjs.extend(localizedFormat);

  let navigate = useNavigate();

  const [dataSource, setDataSource] = useState([]);

  const openModal = (e, data, talentId, userId) => {
    e.stopPropagation();
    setIsModalOpen(true);
    const modalData = {
      talentId: talentId,
      data: data,
      userId: userId
    }
    setModalData(modalData);
  };

  const redirectToCompanyProfile = (userId, companyId) => { 
    impersonate(USER_TYPE.CANDIDATE, userId, `/company-profile/${companyId}`);    
 }

  const handleRemoveCandidate = async (e, item, index, talentId) => {
    e.stopPropagation();
    setRemoveCandidateLoading((prev) => ({ ...prev, [index]: true }));
    const data = {
      candId: talentId,
      empId: item.AccountId
    }
    try {
      const response = await candidateApi.removeCandidate(data);
      if (response.status == HTTP_RESPONSE_CODES.SUCCESS) {
        notification.open({
          duration: 5,
          message: (
            <div
              className="messageCon"
            >
              <span className="tikImage" ><img src={GreenTik} /></span>
              <p
                className="RemovedText"
              >
                Removed from '{item.PvtEmpName}' private marketplace successfully
              </p>
            </div>
          ),
          placement: "topLeft"
        });
        setIsModalOpen(false);
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.message
      });
    } finally {
      setRemoveCandidateLoading((prev) => ({ ...prev, [index]: false }));
      fetchCandidates();
    }
  };

  const displayLocation = (arg) => {
    try {
      const { Location = {}, states = [] } = arg;
      if (states?.length > 0) return states.join(",");
      else return Location?.Location || "N/A";
    } catch (error) {
      return "N/A";
    }
  };

  const candidateRow = (item) => {    
    let name =
      item.Profiles.FirstName == null && item.Profiles.LastName == null
        ? "NA"
        : item.Profiles.FirstName + " " + item.Profiles.LastName;
    return {
      key: `${item._id}`,
      candidate_details: (
        <div className="UserCell">
          <div className="UserPicName">
          {item?.Profiles?.PictureUrl && !item?.Profiles?.PictureUrl.includes("no-pic")  ? (
              <img
                src={process.env.REACT_APP_S3_URL +"/"+ item?.Profiles?.PictureUrl}
                alt=""
                onError={(e) =>
                  (e.target.src = `${process.env.REACT_APP_S3_URL}/content/img/no-pic.png`)
                }
              />
            ) : (
              <span className="UserChar">
                {item?.Profiles?.FirstName ? item?.Profiles?.FirstName.slice(0, 1).toUpperCase() : "N"}
              </span>
            )}
            <span className="UserFullName">
              <Tooltip title={name}>{name}</Tooltip>
            </span>

            <AiFillStar className="starIcon" />
            <span className="Rating">
              {item.Profiles?.Rating ? item.Profiles?.Rating : 0}
            </span>
            <span className="Review">
              ({item.Profiles?.Review ? item.Profiles?.Review : 0})
            </span>

            <div className="LastLoginInfo">
              <p className="UserNonActive "></p>
              <span className="LastLoginTime">
                {item?.LastLoginDate !== "NA"
                  ? dayjs(item?.LastLoginDate).fromNow()
                  : item?.LastLoginDate}
              </span>
            </div>
          </div>
          <div className="UserOtherInfo">
            <div className={"UserOtherInfoInside"}>
              <img src={emailIcon} alt="" />
              <span>
                {item.EmailAddress == null ? "NA" : item.EmailAddress}
              </span>
            </div>
            <div className="UserOtherInfoInside">
              <img src={phoneIcon} alt="" />
              <span>
                {" "}
                {item.Profiles.MobilePhone == null
                  ? "NA"
                  : "+1 " + item.Profiles.MobilePhone}
              </span>
            </div>
          </div>
          <div className="UserOtherInfo">
            <div className="UserOtherInfoInside">
              <img src={locationIcon} alt="" />
              <span>{displayLocation(item.Profiles)}</span>
            </div>
            <div className="UserOtherInfoInside">
              <img src={citizenShipIcon} alt="" />
              <span>
                {item.Profiles.VisaStatuses?.VisaStatusName
                  ? item.Profiles.VisaStatuses?.VisaStatusName
                  : "NA"}
              </span>
            </div>
          </div>
          {item?.Profiles?.ResumeFileName && (
            <a
              href="#!"
              className="Resume"
              onClick={(e) => {
                e.stopPropagation();
                window.open(process.env.REACT_APP_S3_URL +"/"+ item?.Profiles?.ResumeFileName, "_blank");
              }}
            >
              <img src={resumeIcon} alt="" />
              <span>Resume</span>
            </a>
          )}
        </div>
      ),
      private: (
        <div className="Private-cantiner">
          {item.EmployeeAssociation?.length > 0
            ? item.EmployeeAssociation.map((data, index) => {
              if (index > 3) return null; // Return null instead of undefined
              return (
                <div className="PrivatePicName" style={{ cursor: "pointer" }} onClick={(e) => openModal(e, item.EmployeeAssociation, item?.AccountId, item._id)} key={"pvt_" + index}>
                  {" "}
                  {/* Add a unique key */}
                  <span>
                    <Avatar
                      src={
                        data?.PictureUrl
                          ? `${process.env.REACT_APP_S3_URL}/${data?.PictureUrl}`
                          : null
                      }
                      style={{ fontSize: "14px" }}
                      size={24}
                    >
                      {index > 2
                        ? data?.length - 2
                        : data?.PvtEmpName
                          ? data?.PvtEmpName[0]
                          : "N/A"}
                    </Avatar>
                  </span>
                  <span className="PrivatePicName-Pvt-Name">
                    {data?.PvtEmpName}
                  </span>
                </div>
              );
            })
            : "N/A"}
        </div>
      ),
      info: (
        <div className="InfoCell">
          <span>
            AP{" "}
            <span className="infoBold">
              {
                AuthenticationProviderName[
                item.AuthenticationProviderId
                  ? item.AuthenticationProviderId
                  : 0
                ]
              }
            </span>
          </span>
          <span>
            Source{" "}
            <span className="infoBold">
              {item.MCSource
                ? item.MCSource !== "null"
                  ? item.MCSource
                  : "NA"
                : "NA"}
            </span>
          </span>
          <span>
            Campaign{" "}
            <span className="infoBold">
              {item.MCCampaign
                ? item.MCCampaign !== "null"
                  ? item.MCCampaign
                  : "NA"
                : "NA"}
            </span>
          </span>
          <span>
            Created On{" "}
            {item?.Created !== null
              ? dayjs(item?.Created).format("LLL").replace(",", "")
              : dayjs(item?.Created).format("LLL").replace(",", "")}
          </span>
        </div>
      ),
      profession: (
        <div className="ProfessionCell">
          <span>
            {item?.Professions?.ProfessionCode == null
              ? "NA"
              : item?.Professions?.ProfessionCode}
          </span>
        </div>
      ),
      status: (
        <div className={"StatusCell"}>
          <div className={"Status"}>
            {item?.SoftDelete ? <span className={"StatusInactive"}>Deleted</span> : item.IsActive === 0 ? <span className={"StatusInactive"}>Inactive</span> : <span className={"StatusActive"}>Active</span>}
          </div>
          <div>
            <div className={"CreadtedTime"}>
              Created on{" "}
              {item.Created !== ""
                ? dayjs(item.Created).format("LLL").replace(",", "")
                : "NA"}
            </div>
            <div className={"CreadtedTime"}>
              Last Login on{" "}
              {item.LastLoginDate !== null
                ? dayjs(item.LastLoginDate).format("LLL").replace(",", "")
                : dayjs(item.Created).format("LLL").replace(",", "")}
            </div>
          </div>
        </div>
      ),
      message: (
        <div
          className={`messaging-icon-cell ${item?.Status === "Deactivated" ? "Talent-conversationExists" : null
            }`}
        >
          <div
            className={`messaging-icon ${!item?.adminUnread ? "messaging-icon-cell-grey" : null
              }`}
            // onClick={(e) => {
              
            //   e.stopPropagation();
            //   navigate(`/chat/${item?.AccountId}`);
            // }}
          >
            <Badge
              color="#DB2828"
              dot={item?.adminUnread}
              size={10}
              offset={[8, -9]}
            >
              <img
                src={item?.adminUnread ? chaticon : chaticonGrey}
                alt="chatIcon"
              />
            </Badge>
          </div>
        </div>
      ),
    };
  };

  useEffect(() => {
    if (candidates.length > 0) {
      let candidatesData = candidates[0].data;
      const data = candidatesData.map((item) => candidateRow(item));
      setDataSource(data);
    }
  }, [candidates]);

  return (
    <>
      <Table
        dataSource={dataSource}
        columns={columns}
        loading={isLoading}
        bordered
        pagination={false}
        onRow={(record) => ({
          onClick: () => impersonate(USER_TYPE.CANDIDATE, record.key),
        })}
      />
      {/* Modal */}
      <ModalCommon title="Private Employers" isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}>
        {modalData?.data?.map((item, index) => (
          <div key={index} className="Modal-Container">
            <div className="sub-container">
              <div className="namePicWrapper" onClick={() => redirectToCompanyProfile(modalData.userId, item._id)}>
                <div className="pvtModalPic">
                  <Avatar
                    src={
                      item?.PictureUrl
                        ? `${process.env.REACT_APP_S3_URL}/${item.PictureUrl}`
                        : null
                    }
                    size={24}
                  >
                    {item?.PvtEmpName ? item.PvtEmpName[0] : "N/A"}
                  </Avatar>
                </div>
                <div
                  className="PvtModalName"
                >
                  {item?.PvtEmpName}
                </div>
              </div>
              <span className="btnWrapper">
                <button
                  className="Leave-btn"
                  onClick={(e) => { handleRemoveCandidate(e, item, index, modalData?.talentId) }}
                  disabled={removeCandidateLoading[index]}
                  style={{ cursor: "pointer" }}
                >
                  {removeCandidateLoading[index] ? <Spin /> : "Leave from private marketplace"}
                </button>
              </span>
            </div>
          </div>
        ))}
      </ModalCommon>
    </>
  );
}
